/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookClosedIcon16Regular = forwardRef('BookClosedIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5 4.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 11.235V2.25C13 1.56 12.44 1 11.75 1h-7A2.75 2.75 0 0 0 2 3.75v8.934a2.25 2.25 0 0 0 2.25 2.315h8a.75.75 0 0 0 0-1.5h-8a.75.75 0 1 1 0-1.499h8a.75.75 0 0 0 .75-.75v-.015ZM4.75 2.5c-.69 0-1.25.56-1.25 1.25v6.878c.234-.083.487-.128.75-.128h7.25v-8H4.75Z" })));
});
